<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0">
    <div class="col-sm-3 pad-0">
      <div class="page-title" style="margin: 0px 0px;">
        <ol class="breadcrumb no-background">
          <li class="active"><i class="fa fa-tachometer"></i>&nbsp;<b><span class="rediFIX">i</span><span
                class="blueiFIX">FIX</span></b>
            Dashboard
          </li>
        </ol>
      </div>
    </div>
    <div class="col-sm-3">
      <mat-form-field>
        <mat-label>Current Group:</mat-label>
        <mat-select [(ngModel)]="userGroupSelected" (selectionChange)="onSelectGroup()" class="matSize">
          <mat-option *ngFor="let group of userGroups" [value]="group.groupId" class="matSize">{{group.grpName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="dashboard-content mr-top-5">
    <div class="row mar-lft-rgt-0 font-16">
      <div class="col-sm-9 pad-15">
        <div class="height-40" [hidden]="ticketTypeLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <mat-radio-group (change)="onButtonChange($event)" [hidden]="!ticketTypeLoaded">
          <mat-radio-button *ngFor="let button of radioButton;" [value]="button" [checked]="button.checked">
            {{button.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button>&nbsp;&nbsp;
        </mat-radio-group>
      </div>

      <div class="col-sm-3">
        <mat-form-field class="right mar-lft-9">
          <mat-label>Workspace:</mat-label>
          <mat-select [(ngModel)]="workType" (selectionChange)="onWorkTypeChange()">
            <mat-option *ngFor="let wp of workspaces" [value]="wp.id">{{wp.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <button type="button" class="btn btn-warning radius-0 refresh-btn matRipple right" (click)="onPageLoad()"
          title="refresh">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
    <div class="row mar-lft-rgt-0">

      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLabel0 && !isCrType && !isPrType && isAdmin">
        <div class="card card-style create-ticket-bg shadow border-0 pointer" matRipple (click)="createTicket()">
          <div class="card-body pad-0">
            <h1 class="card-text static-card">Create Ticket</h1>
          </div>
        </div>
      </div>

      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLoading">
        <div class="card card-style shadow border-0">
          <div class="card-body pad-0">
            <img class="loading-gif-70" src="../../../assets/img/loader-70px.gif">
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-3 mar-top-15" *ngFor="let data of tilesData" (click)="goto(data.fid)">
        <div class="card card-style half shadow border-0 pointer" matRipple>
          <div class="card-top" [ngStyle]="{'background-color': data.color_code}">

            <h4 class="card-text top-part top-tesxtarea">{{data.funcDescription}}
              <mat-icon color="black" class="none" id="display_{{data.fid}}">grade</mat-icon>
            </h4>
          </div>
          <div class="card-buttom">
            <img id="loader_{{data.fid}}" src="../../../assets/img/elipsis_loader.gif">
            <h1 class="card-text buttom-number" id="count_{{data.fid}}"></h1>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="isAdmin && isSearchFaq">
        <div class="card card-style Assignment-bg shadow border-0 pointer" matRipple (click)="goToReAssigment()">
          <div class="card-body pad-0">
            <h1 class="card-text static-card">Re Assignment</h1>
          </div>
        </div>
      </div>

      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="isAdmin && isSearchFaq">
        <div class="card card-style search-bg shadow border-0 pointer" matRipple (click)="goToSearch()">
          <div class="card-body pad-0">
            <h1 class="card-text static-card">Search Ticket</h1>
          </div>
        </div>
      </div>

      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="isAdmin && isSearchFaq">
        <div class="card card-style faq-bg shadow border-0 pointer" matRipple (click)="goTofaq()">
          <div class="card-body pad-0">
            <h1 class="card-text static-card">FAQ <br><span class="font-13">(Under Development)</span></h1>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>